import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearPurchaseBill, clearError, clearMessage } from "../redux/manageProductSlice";

const ClearBillModel = ({ visible, onCancel, balance, order_id }) => {
  const dispatch = useDispatch();
  const [amount, setAmount] = useState(0);
  const { loading, error, message } = useSelector((state) => state.sales);

  const ClearBill = (status) => {
    if (amount > balance) {
      alert("Amount must be less than or equal to the balance");
      return;
    }
    const clearBillData = { order_id, amount, status };
    dispatch(clearPurchaseBill(clearBillData));
    onCancel();
  };

  useEffect(() => {
    if (error) {
      alert(error);
      setTimeout(() => {
        dispatch(clearError());
      }, 3000);
    }
    if (message) {
      alert(message);
      setTimeout(() => {
        dispatch(clearMessage());
      }, 3000);
    }
  }, [error, dispatch, message]);

  return (
    visible && (
      <div className="fixed top-0 left-0 right-0 bottom-0 flex justify-center items-center bg-black bg-opacity-50 z-50">
        <div className="bg-white p-6 rounded-lg w-1/3 min-w-[300px]">
          <h3 className="text-lg font-semibold">Clear Balance: Rs {balance}</h3>

          <input
            type="number"
            value={amount}
            onChange={(e) => setAmount(Number(e.target.value))}
            placeholder="Amount"
            className="border p-2 w-full rounded-md mt-6"
          />

          <div className="flex justify-between gap-4 mt-8">
            <button
              onClick={onCancel}
              className="px-6 py-2 bg-red-400 w-1/2 rounded-lg text-center text-gray-800"
            >
              Cancel
            </button>
            {Number(amount) !== Number(balance) && (
              <button
                onClick={() => ClearBill("pending")}
                className="px-6 py-2 bg-yellow-500 w-1/2 rounded-lg text-center text-gray-800"
              >
                Stay Pending
              </button>
            )}
          </div>

          <button
            onClick={() => ClearBill("complete")}
            className="px-6 py-2 bg-green-600 mt-2 w-full rounded-lg text-center text-white"
          >
            {loading ? "...Loading" : "Mark as Clear"}
          </button>
        </div>
      </div>
    )
  );
};

export default ClearBillModel;
